import axios from "axios";
import { timeoutBig, timeoutIntegration, urlApi, getApiUrl } from ".";
import { SecureStorage } from "@helpers/storage";
import { handleApiError } from "./errorHandler";

export function PaymentData(qrCode) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      let config = {
        method: "get",
        url: getApiUrl(`/api/v1/Ticket/ConsultaTicket?qrCode=${qrCode}`),
        timeout: timeoutIntegration,
        headers: {
          Authorization: "Bearer " + token,
        },
      };
      
      axios(config)
        .then((response) => {
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "consultar ticket"));
        });
    });
  });
}

export function PaymentTicketSoftpark(
  value,
  cardNumber,
  cvv,
  expiration,
  idUnity,
  plate,
  ticket,
  idCard,
  payType,
  idFraction,
  amountFraction,
  nmUnity
) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      let config = {
        method: "post",
        url: getApiUrl("/api/v1/ticket/paymentticket"),
        timeout: timeoutBig,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          sistema: "Softcase Mobile",
          "payType": payType,
        },
        data: {
          numeroTicket: ticket,
          valorTotal: value,
          formaPagamento: "credito",
          terminal: "1",
          placa: plate,
          idGaragem: idUnity,
          bandeira: "mastercard",
          autorizacao: "1234",
          nsu: "12345",
          codSeguranca: cvv,
          nmUnidade: nmUnity
        },
        params: {
          "idFraction": idFraction ?? "0",
          "amountFraction": amountFraction ?? "0",
        }
      };

      if (!idCard) {
        config.data = {
          ...config.data,
          "cartao": cardNumber ?? "",
          "codSeguranca": cvv ?? "",
          "validadeCartao": expiration ?? "",
        }
      } else {
        config.data = {
          ...config.data,
          "codigoCartao": idCard ?? "",
        }
      }
      
      axios(config)
        .then((response) => {
          if (response.data.code != "0") {
            reject(response.data);
          }
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "processar pagamento"));
        });
    });
  });
}

export function PaymentContract(
  value,
  cardNumber,
  cvv,
  expiration,
  idUnity,
  idMonthlyTablePrice,
  amountSpace,
  idCard,
  payType
) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {
      let config = {
        method: "post",
        url: getApiUrl("/api/v1/ClientIntegration/AddClientMonthlyContract"),
        timeout: timeoutBig,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          cdUnity: idUnity,
          cdMonthlyTablePriceId: idMonthlyTablePrice,
          numberOfVacancys: amountSpace,
          payType: payType,
        },
        data: {
          numeroTicket: "",
          valorTotal: value,
          formaPagamento: "credito",
          terminal: "-1",
          placa: "",
          idGaragem: idUnity,
          codSeguranca: cvv,
        },
      };

      if (!idCard) {
        config.data = {
          ...config.data,
          cartao: cardNumber,
          bandeira: "mastercard",
          nsu: "12345",
          validadeCartao: expiration,
        }
      } else {
        config.data = {
          ...config.data,
          codigoCartao: idCard,
        }
      }
      axios(config)
        .then((response) => {
          if (response.data.code != "200") {
            reject(response.data);
          }
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "processar contrato"));
        });
    });
  });
}

export function PaymentBill(
  value,
  cardNumber,
  cvv,
  expiration,
  idUnity,
  idVacancy,
  nossoNumero,
  idCard,
  payType
) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {

      let config = {
        method: "post",
        url: getApiUrl("/api/v1/ClientIntegration/AddClientBilling"),
        timeout: timeoutBig,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
          cdUnity: idUnity,
          cdVacancy: idVacancy,
          paymentMethod: "credito",
          NossoNumero: nossoNumero,
          value: value,
          payType: payType
        },
        data: {
          numeroTicket: "",
          valorTotal: value,
          formaPagamento: "credito",
          terminal: "-1",
          placa: "",
          idGaragem: idUnity,
          codSeguranca: cvv,
        },
      };

      if (!idCard) {
        config.data = {
          ...config.data,
          cartao: cardNumber,
          bandeira: "mastercard",
          nsu: "12345",
          validadeCartao: expiration,
        }
      } else {
        config.data = {
          ...config.data,
          cdCartao: idCard,
        }
      }
      axios(config)
        .then((response) => {
          if (response.data.code != "200") {
            reject(response.data);
          }
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "processar fatura"));
        });
    });
  });
}

export function BuyCoins(
  idCoin,
  totalValue,
  cardNumber,
  cvv,
  expiration,
  idCard,
) {
  return new Promise((resolve, reject) => {
    SecureStorage.getItemAsync("TokenUser").then((token) => {

      let config = {
        method: "post",
        url: getApiUrl("/api/v1/Coin/BuyCoins"),
        timeout: timeoutBig,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        data: {
          "idCoin": idCoin,
          "valorTotal": totalValue,
          "codSeguranca": cvv
        },
      };

      if (!idCard) {
        config.data = {
          ...config.data,
          "nmCartao": cardNumber ?? "",
          "codSeguranca": cvv ?? "",
          "validadeCartao": expiration ?? "",
        }
      } else {
        config.data = {
          ...config.data,
          "codigoCartao": idCard ?? "",
        }
      }
      axios(config)
        .then((response) => {
          if (response.data.code != "0") {
            reject(response.data);
          }
          if (response.status == 200) {
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch((error) => {
          reject(handleApiError(error, "comprar moedas"));
        });
    });
  });
}